<template>
    <x-page title="Pengunjung (Terhapus)">
        <template #header-actions>
            <x-back-button :disabled="isLoading"
                :display-warning="false"
                :clickHandler="router => router.replace('/admin/visitors')" />
        </template>

        <x-table-count :pagination="{ current: resources.length, ...meta }" />
        <x-table :headers="[
            '#',
            'ID',
            'Nama Lengkap',
            {
                label: 'Usia',
                visible: shouldDisplayAge,
            },
            'Email',
            'Status',
            'Alamat',
            'Jenis Kelamin',
            '',
        ]" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link :to="`/admin/visitors/${resource.id}`"
                        title="Klik untuk lihat detail">
                        {{ resource.id }}
                    </router-link>
                </td>
                <td class="nowrap">
                    <router-link :to="`/admin/visitors/${resource.id}`"
                        title="Klik untuk lihat detail">
                        {{ resource.name }}
                    </router-link>
                    <div v-if="Boolean(resource.user_account)">
                        <x-label color="primary"
                            :title="`Tersambung dengan user account ${resource.user_account.email}`">
                            <i class="fa fa-user" /> {{ resource.user_account.name }}
                        </x-label>
                    </div>
                </td>
                <td v-if="shouldDisplayAge">
                    {{ resource.age || '-' }}
                </td>
                <td class="nowrap">
                    {{ resource.email }}
                </td>
                <td class="nowrap">
                    {{ resource.status }}
                </td>
                <td class="nowrap">
                    <div v-html="$options.filters.nl2br(resource.address)" />
                </td>
                <td class="nowrap">
                    {{ resource.gender }}
                </td>
                <td>
                    <x-quick-action-button :disabled="isLoading"
                        title="Restore"
                        icon="refresh"
                        @click="() => restoreResource(resource)"
                        v-if="can('restoreMembers')" />
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" :query="$route.query" />
    </x-page>
</template>

<script>
import XActionButton from '../../components/XActionButton.vue'
import XAjaxDropdown from '../../components/XAjaxDropdown.vue'
import XCheckboxWrapper from '../../components/XCheckboxWrapper.vue'
import XCreateButton from '../../components/XCreateButton.vue'
import XQuickDeleteButton from '../../components/XQuickDeleteButton.vue'
import XQuickEditButton from '../../components/XQuickEditButton.vue'
import XExcelExportButton from '../../components/XExcelExportButton.vue'
import XExcelImportButton from '../../components/XExcelImportButton.vue'
import XExcelImportModal from '../../components/XExcelImportModal.vue'
import XFilterBox from '../../components/XFilterBox.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XLabel from '../../components/XLabel.vue'
import XPage from '../../components/XPage.vue'
import XPagination from '../../components/XPagination.vue'
import XTable from '../../components/XTable.vue'
import { availableMemberStatuses, handleGeneralXhrError, warningPrompt } from '../../helpers'
import FilterableMixin from '../../mixins/FilterableMixin'
import PaginationMixin from '../../mixins/PaginationMixin'
import PermissionMixin from '../../mixins/PermissionMixin'
import XQuickActionButton from '../../components/XQuickActionButton.vue'
import XInputGroup from '../../components/XInputGroup.vue'
import XTableCount from '../../components/XTableCount.vue'
import XBackButton from '../../components/XBackButton.vue'

const defaultFilters = {
    age_min: null,
    age_max: null,
    group_category_id: null,
    group_role_id: null,
    search: null,
    status: null,
}

export default {
    beforeRouteUpdate(to, from, next) {
		this.fetchResources(to)
		next()
	},
    components: {
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XExcelExportButton,
        XCheckboxWrapper,
        XFormGroup,
        XExcelImportModal,
        XFilterBox,
        XAjaxDropdown,
        XPagination,
        XLabel,
        XActionButton,
        XQuickActionButton,
        XInputGroup,
        XTableCount,
        XBackButton,
    },
    computed: {
        availableStatuses() {
            return availableMemberStatuses()
        },
        shouldDisplayAge() {
            return true
        },
    },
    created() {
        this.preselectFilters(defaultFilters)
        this.handleFilter().catch(() => {
            this.fetchResources()
        })
    },
    data() {
        return {
            defaultGroupCategory: null,
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
            selectedGroupCategory: null,
            selectedGroupRole: null,
        }
    },
    methods: {
        restoreResource(resource) {
            warningPrompt({
                name: resource.name,
                text: `Restore ${resource.name}?`,
                onConfirm: () => {
                    this.isLoading = true
                    const request = axios.post(`/api/visitors/${resource.id}/restore`)
                        .then(() => {
                            this.$notify({
                                type: 'success',
                                title: `Berhasil`,
                                text: `${resource.name} direstore!`,
                            })
                            this.fetchResources()
                        })
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false
                    })
                },
            })
        },
        fetchResources(route = this.$route) {
            this.isLoading = true
            const request = axios.get('/api/visitors', {
                params: route.query
            })
            .then(response => {
                this.resources = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                    with: [
                        'user_account',
                    ],
                    without_global_scopes: 1,
                    trashed: 1,
                }),
            })
        },
        resetFilter() {
            this.filters = { ...defaultFilters }
            this.handleFilter()
        },
    },
    mixins: [
        FilterableMixin,
        PaginationMixin,
        PermissionMixin,
    ],
    watch: {
        'filters.group_category_id': {
            handler(id) {
                this.syncFilterToProperty(id, 'selectedGroupCategory', `/api/group-categories/${id}`)
            },
            immediate: true,
        },
        'filters.group_role_id': {
            handler(id) {
                this.syncFilterToProperty(id, 'selectedGroupRole', `/api/group-roles/${id}`)
            },
            immediate: true,
        },
        selectedGroupCategory: {
            handler(resource) {
                this.syncPropertyToFilter(resource, 'group_category_id')
            },
            deep: true,
        },
        selectedGroupRole: {
            handler(resource) {
                this.syncPropertyToFilter(resource, 'group_role_id')
            },
            deep: true,
        },
    }
}
</script>
